import watchSaveMenuCategoriesSaga from './saveMenuCategories';

const MenuCategoriesSagas = [watchSaveMenuCategoriesSaga()];

export default MenuCategoriesSagas;
